import { lazy, Suspense } from "react";
import type { FuelNetworkCharts } from "@/lib/analytics";

function ChartGridSkeleton() {
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className="rounded-3xl bg-canvas p-4 sm:p-5">
          <div className="h-3 w-28 skeleton-shimmer rounded-full" />
          <div className="mt-2 h-3 w-44 skeleton-shimmer rounded-full" />
          <div className="mt-4 h-[220px] rounded-2xl bg-canvas-hover" />
        </div>
      ))}
    </div>
  );
}

const FuelNetworkCharts = lazy(() =>
  import("./FuelNetworkCharts").then((mod) => ({ default: mod.FuelNetworkCharts }))
);

export function LazyFuelNetworkCharts({ charts }: { charts: FuelNetworkCharts }) {
  return (
    <Suspense fallback={<ChartGridSkeleton />}>
      <FuelNetworkCharts charts={charts} />
    </Suspense>
  );
}
